import { theme } from '@/app/common/providers/theme-provider/theme';
import { config } from '@/config/environment';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { useRouter } from 'next/navigation';

const Container = styled.div`
  height: 323px;
  width: 288px;
  background-color: #311c32;
  border-radius: 19px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: translateY(0);
  transition: transform ease-in-out 0.2s;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.35);
  &:hover {
    transform: translateY(-10px);
  }
`;
const Text = styled(Typography)`
  font-family: var(--font-work-sans);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 136.8%;
  color: ${theme.palette.common.cream};
`;
const AddSign = styled(Typography)`
  font-family: var(--font-work-sans);
  font-style: normal;
  font-weight: 400;
  font-size: 64px;
  line-height: 112.3%;
  text-align: center;
  color: ${theme.palette.common.cream};
`;
const CreateNewCard = (): React.ReactElement | null => {
  const router = useRouter();

  if (config.platformMode === 'archive') {
    return null;
  }
  const createExperience = async () => {
    await router.push(`/my-experiences/create`);
  };
  return (
    <Container onClick={createExperience}>
      <AddSign>+</AddSign>
      <Text>Create new</Text>
    </Container>
  );
};

export default CreateNewCard;
